import { getApiUrl } from '../../lib';

const trackPopupEvent = pathname => {
  const url = getApiUrl() + pathname;
  window._paq?.push(['trackEvent', 'Odczyt informacji o obiekcie', url]);
};

export default trackPopupEvent;
